<template>
  <OuterCasing class="main user-select" :isScroll="isScroll" style="max-width: 450px;margin: 0 auto;position: inherit;">
    {{ /* 组合一些全局的组件，比如 loading、notify */ }}
    <LoadingComponents />
   <!-- 地图页面要加载google sdk，每次重来很慢 -->
    <keep-alive include="select-address, select-address-province">
      <router-view />
    </keep-alive>
  </OuterCasing>
</template>

<script>
//  预留的外层壳，以防要加点什么没预留后路
import OuterCasing from '$common/components/outer-casing';
import LoadingComponents from '$superAppUser/components/loading-components';
import storage from '$common/utils/storage';
import WechatJssdk from '$common/utils/wechat/web-jssdk';
export default {
  components: { OuterCasing, LoadingComponents },
  data() {
    return {
      isScroll: false,
      userInfo: undefined,
      //  需要用到滚动插件的路由
      scrollNames: ['confirm-order', 'add-address', 'order-detail', 'cart']
    }
  },
  created() {
    this.$root.maxWidth = 450;
    this.$root.maxFontSizeWidth = 375;
    document.body.style.cssText += 'background-color: #f6f6f6';

    // 若 URL query 中带有 wechatConfig=0 则禁用微信 SDK config
    const shouldConfigWechatSDK = !/wechatConfig=0/.test(window.location.search)
    shouldConfigWechatSDK && WechatJssdk.config()?.then(() => WechatJssdk?.share());

    const redirectRouteName = window?.ssrConfig?.routerConfig?.short?.redirectRouteName
    if (redirectRouteName) {
      this.$router.push({ name: redirectRouteName })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.userInfo = storage.getItem('userInfo');
    });
  },
  watch: {
    $route(val) {
      this.isScroll = !!(this.$root.getIosVersion && this.$root.getIosVersion.length && this.$root.getIosVersion[0] < 12 && this.scrollNames.indexOf(val.name) !== -1);
      Vue.filter('loading')(false);
      Vue.filter('unusual-popup')(false, '')
    }
  }
}
</script>

<style lang="stylus">
  .pc {
    // font-size: 102Px !important;
    // max-width: 1024Px !important;
    font-size: 45Px !important;
    max-width: 450Px !important;
  }
  .im-web-iframe {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
</style>
